
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns97be3f7bb64e09462aed1fbb30e0723een from './en.yaml'
            i18n.addResourceBundle('en', '97be3f7bb64e09462aed1fbb30e0723e', flattenObject(ns97be3f7bb64e09462aed1fbb30e0723een), true, true);
        
        export default '97be3f7bb64e09462aed1fbb30e0723e';
    